export const ProductActionType = {
  LOAD_LIST_START: 'product/LOAD_LIST_START',
  LOAD_LIST_SUCCESS: 'product/LOAD_LIST_SUCCESS',
  LOAD_LIST_FAILURE: 'product/LOAD_LIST_FAILURE',
  /** Update total count only (e.g. dashboard) without replacing the current list rows. */
  SET_LIST_TOTAL: 'product/SET_LIST_TOTAL',
  SET_SELECTED: 'product/SET_SELECTED',
  MUTATION_START: 'product/MUTATION_START',
  CREATE_SUCCESS: 'product/CREATE_SUCCESS',
  UPDATE_SUCCESS: 'product/UPDATE_SUCCESS',
  DELETE_SUCCESS: 'product/DELETE_SUCCESS',
  SET_ERROR: 'product/SET_ERROR',
  CLEAR_ERROR: 'product/CLEAR_ERROR',
}

export function createInitialProductState() {
  return {
    products: [],
    listTotal: 0,
    listPage: 1,
    listLimit: 20,
    selectedProduct: null,
    listLoading: false,
    mutationLoading: false,
    error: null,
  }
}

export function productReducer(state, action) {
  switch (action.type) {
    case ProductActionType.LOAD_LIST_START:
      return { ...state, listLoading: true, error: null }
    case ProductActionType.LOAD_LIST_SUCCESS: {
      const { items, total, page, limit } = action.payload
      return {
        ...state,
        listLoading: false,
        products: items,
        listTotal: total,
        listPage: page,
        listLimit: limit,
      }
    }
    case ProductActionType.LOAD_LIST_FAILURE:
      return { ...state, listLoading: false, error: action.payload }
    case ProductActionType.SET_LIST_TOTAL:
      return { ...state, listTotal: action.payload }
    case ProductActionType.SET_SELECTED:
      return { ...state, selectedProduct: action.payload }
    case ProductActionType.MUTATION_START:
      return { ...state, mutationLoading: true, error: null }
    case ProductActionType.CREATE_SUCCESS: {
      const created = action.payload
      const prepend = state.listPage === 1
      return {
        ...state,
        mutationLoading: false,
        products: prepend ? [created, ...state.products] : state.products,
        listTotal: state.listTotal + 1,
      }
    }
    case ProductActionType.UPDATE_SUCCESS: {
      const updated = action.payload
      return {
        ...state,
        mutationLoading: false,
        products: state.products.map((p) =>
          String(p.id) === String(updated.id) ? updated : p,
        ),
        selectedProduct:
          state.selectedProduct && String(state.selectedProduct.id) === String(updated.id)
            ? updated
            : state.selectedProduct,
      }
    }
    case ProductActionType.DELETE_SUCCESS: {
      const id = action.payload
      return {
        ...state,
        mutationLoading: false,
        products: state.products.filter((p) => String(p.id) !== String(id)),
        listTotal: Math.max(0, state.listTotal - 1),
        selectedProduct:
          state.selectedProduct && String(state.selectedProduct.id) === String(id)
            ? null
            : state.selectedProduct,
      }
    }
    case ProductActionType.SET_ERROR:
      return { ...state, error: action.payload, listLoading: false, mutationLoading: false }
    case ProductActionType.CLEAR_ERROR:
      return { ...state, error: null }
    default:
      return state
  }
}
